import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { BLACK, FEED_BACK, RED } from '../../../../theme/colorConstants';
import { isValidWorkersCompCode } from '../../helpers';
import { textFieldSx } from '../AutoSaveTextField';

const rootSx = { display: 'flex', flexDirection: 'column', gap: '4px' };

const validIconSx = { color: FEED_BACK.GREEN_70, fontSize: '18px' };

const codeFieldSx = {
  ...textFieldSx,
  '& .MuiOutlinedInput-input': { fontFamily: 'monospace', fontSize: '14px' },
};

const errorTextSx = { color: RED[80], fontSize: '12px' };

const helperTextSx = { color: BLACK[70], fontSize: '12px' };

const WorkersCompCodeInput = ({ id, value, helperText, onChange, onSubmit }) => {
  const intl = useIntl();
  const isValid = isValidWorkersCompCode(value);
  const showFormatError = !!value && !isValid;

  return (
    <Box sx={rootSx}>
      <TextField
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value.replace(/\s/g, '').toUpperCase())}
        onKeyDown={(event) => {
          if (event.key === 'Enter') onSubmit();
        }}
        error={showFormatError}
        size="small"
        fullWidth
        InputProps={{
          inputProps: { maxLength: 7 },
          endAdornment: isValid ? (
            <InputAdornment position="end">
              <CheckIcon data-testid="workers-comp-code-valid" sx={validIconSx} />
            </InputAdornment>
          ) : null,
        }}
        sx={codeFieldSx}
      />
      {showFormatError && (
        <Typography sx={errorTextSx}>
          {intl.formatMessage({ id: 'pt.detail.locations.workersCompCode.invalid' })}
        </Typography>
      )}
      {!showFormatError && helperText && <Typography sx={helperTextSx}>{helperText}</Typography>}
    </Box>
  );
};

WorkersCompCodeInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default WorkersCompCodeInput;
